/* eslint-disable max-len */
import Image from "next/image";
import Link from "next/link";

import { ROUTES } from "@/helpers/routes";
import PageSeo from "@/shared/components/PageSeo";

import Layout from "../../shared/components/layout";

export default function Newsletter() {
    const setGAnalytics = (reportName: string) => {
        gtag("event", "Download Report", { description: reportName });
    };

    return (
        <div>
            <Layout>
                <PageSeo title={"Reports | The Gender Index"} pathname={ROUTES.reports} />
                <div className='singleLayout reportPage'>

                    <h3>The Gender Index reports </h3>
                    <p className='body-default-copy textCenter'>Our reports and national narratives are free to download, read and share.
                        We hope they stimulate ideas, discussion and policy decisions to inspire positive change.</p>
                    <div className='tabsNavigation'>
                        <ul className='commonList'>
                            <li className='active'>
                                <Link href="/reports">Annual Reports</Link>
                            </li>
                            <li>
                                <Link href="/reports/narratives">Narratives</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="reportList">
                        <ul className="commonList">
                            <li>
                                <div className="reportCover">
                                    <Image
                                        src="/images/reports/2026.jpg"
                                        alt="report_cover_image_2026"
                                        width={320}
                                        height={414}
                                        loading="lazy" />
                                </div>
                                <div className="reportDetail">
                                    <h2>TGI 26 report</h2>
                                    <p className='body-default-copy'>
                                        The Gender Index Report 2026 provides the most comprehensive,
                                        data-driven view of female entrepreneurship across the UK. Drawing on millions of companies and directors,
                                        it tracks where progress is happening, where it is stalling, and what that means for economic performance.</p>
                                    <p className='body-default-copy'>
                                        Powered by advanced AI,  the report goes beyond observation. It benchmarks performance across regions,
                                        sectors and generations, and highlights the economic cost of inaction.
                                    </p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/uploads/Reports/TGI-2026-report.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("2026 report")}>Download report</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="reportCover">
                                    <Image
                                        src="/images/reports/2025.png"
                                        alt="report_cover_image"
                                        width={320}
                                        height={414}
                                        loading="lazy" />
                                </div>
                                <div className="reportDetail">
                                    <h2>TGI 25 report</h2>
                                    <p className='body-default-copy'>With our 2025 report, we’re taking an exciting step
                                        forward by applying predictive modelling to our data.
                                        This means not only can we see what’s changed over
                                        the last year, but we can also look ahead into the future.</p>
                                    <p className='body-default-copy'>Using company data from 2010 onwards and the
                                        algorithms we’ve developed, this year’s report projects
                                        what the picture may be like in 2030.</p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/uploads/Reports/TGI-2025-report.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("2025 report")}>Download report</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="reportCover">
                                    <Image
                                        src="/images/report-cover24.jpg"
                                        alt="report_cover_image"
                                        width={320}
                                        height={414}
                                        loading="lazy" />
                                </div>
                                <div className="reportDetail">
                                    <h2>TGI 24 report</h2>
                                    <p className='body-default-copy'>Welcome to The Gender Index Report 2024. Produced through a unique combination of leading academic research, big data and cutting-edge technology, discover the latest trends in female entrepreneurship across the UK in 2023. Covering over 8.8 million officers from nearly five million active companies, the data has been segmented and analysed nationally; for England, Scotland, Wales and Northern Ireland; and the English regions, for targeted decision-making.</p>
                                    <p className='body-default-copy'>Our scope has widened to include access to investment capital and secured debt, plus import and export activity. This is in addition to analysis of ethnic minority-led companies, the generation of the leadership, sector, fast growth and more. In an election year, this data will be invaluable in shaping policy to address the gender imbalance in UK business – now and into the future.</p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/uploads/Reports/TGI-2024-Report.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("2024 report")}>Download report</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="reportCover">
                                    <Image
                                        src="/images/report-cover.jpg"
                                        alt="report_cover_image"
                                        width={320}
                                        height={414}
                                        loading="lazy" />
                                </div>
                                <div className="reportDetail">
                                    <h2>TGI 23 report</h2>
                                    <p className='body-default-copy'>We invite you to explore the insights in our latest report which draws comparisons between the activity of female-led
                                        companies in 2021/2022 and 2022/2023. There are some unexpected results which you can view in full here.</p>
                                    <p className='body-default-copy'>Our in-depth analysis covers 8m+ unique directors, 4.5m+ active companies and 1,276 Venture Capital and Private Equity investors and it highlights the ongoing challenges for female-led companies accessing all forms of external capital.</p>
                                    <p className='body-default-copy'>This year we’ve also widened our focus to include ethnic minority female-led companies and the most represented (and under-represented) generations in entrepreneurship.</p>
                                    <p className='body-default-copy'>Whether you’re a policy maker, in local or national government, corporate, researcher, investor, educator or female entrepreneur, our transparent findings can help you to drive change and support a more diverse economy.</p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/uploads/Reports/TGI-2023-Report.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("2023 report")}>Download report</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                {/* <img
                                    src="/images/report_cover_2022.png"
                                    alt="report_cover_image" /> */}
                                <div className="reportCover">
                                    <Image
                                        src="/images/report_cover_2022.png"
                                        alt="report_cover_image"
                                        width={320}
                                        height={414}
                                        loading="lazy" />
                                </div>
                                <div className="reportDetail">
                                    <h2>TGI 22 report</h2>
                                    <p className='body-default-copy'>We are delighted to have launched The Gender Index and we invite you to share our ambition to create
                                        a more equal future by providing, for the first time, a clear and accurate picture of the UK company landscape analysed by gender.</p>
                                    <p className='body-default-copy'>The Gender Index is groundbreaking and is the largest research study into female entrepreneurship ever undertaken.</p>
                                    <p className='body-default-copy'>It accurately measures the number of female-led companies and their impact on the UK economy. AI-powered, it holds live data on more than
                                        4m active UK companies, constantly refreshed and always up-to-date.</p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/uploads/Reports/The-Gender-Index-Report-2022.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("2022 report")}>Download report</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </Layout>
        </div>
    );
}

